import React, { FC, LegacyRef } from 'react'
import {
	AccordionComponent,
	FormNavigationItem,
	Indent,
	UICurrencySuffix,
	UISizes,
	CurrencyInput,
} from 'LibNeo'
import { SetNavElement } from 'Src/hooks/useNav'
import { useSelector } from 'react-redux'
import { FormNames } from 'Constants/FormNames'
import { FieldNames } from 'Constants/FieldNames'
import { currencyNumber, WrappedFormUtilsExtended } from 'Helpers'
import {
	bgLimitRequestSelector,
	BgFormRowElement,
	WhiteBlock,
	getStatusByType,
	normalizeAmount,
	limitRequestAmountLength,
	BgLimitRequestFull,
} from 'Pages/ibro'
import { formsSelectors } from 'Modules'

interface ComponentProps {
	setNavElement: SetNavElement
	blockItem: Required<FormNavigationItem>
}

export const LimitSize: FC<ComponentProps> = ({ setNavElement, blockItem }) => {
	const getForm = useSelector(formsSelectors.getGlobalForm)
	const form = getForm(FormNames.BROKER.LIMIT) as WrappedFormUtilsExtended
	const item = useSelector(bgLimitRequestSelector.selectCurrentLimitRequest) as BgLimitRequestFull

	const { required_fields, locked_fields } = item

	return (
		<div ref={setNavElement(blockItem.idx) as LegacyRef<HTMLDivElement>}>
			<WhiteBlock>
				<AccordionComponent
					id={blockItem.title}
					noExpand
					titleText={blockItem.title}
					status={getStatusByType(blockItem.type)}
					titleSize={UISizes.BIG}
				>
					<Indent top={40}>
						<BgFormRowElement
							fields={[FieldNames.AMOUNT]}
							fieldName={FieldNames.AMOUNT}
							lockedFields={locked_fields}
							label="Размер запрашиваемого лимита"
							lockedElem={currencyNumber(Number(item[FieldNames.AMOUNT]))}
						>
							<CurrencyInput
								form={form}
								fieldName={FieldNames.AMOUNT}
								initialValue={item[FieldNames.AMOUNT]}
								required={required_fields.includes(FieldNames.AMOUNT)}
								suffix={UICurrencySuffix.DEFAULT}
								fieldOptions={{
									normalize: normalizeAmount(limitRequestAmountLength),
								}}
							/>
						</BgFormRowElement>
					</Indent>
				</AccordionComponent>
			</WhiteBlock>
		</div>
	)
}
